<template>
  <div class="branding-elements">
    <div class="element-container">
        <div class="logo-slot-container">
            <slot></slot>
        </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'branding-elements-layout'
});
</script>

<style lang="stylus" scoped>
  .branding-elements {
    width: 528px;
    min-height: 528px;
    margin-right: 64px;
    margin-left: auto;
            
    .element-container {
      padding: 64px;
      min-height: 400px;
      background-color: white;

      img {
        max-width: 100%;
        max-height: 100%;
      }

      .logo-slot-container {
          &.primary {
            min-height: 152px;
            margin-bottom: 48px;
          }
      }
    }
  }
</style>